let counter = 0

/** Short, collision-resistant id (crypto-random + monotonic counter). */
export function uid(prefix = 'id') {
  const rand =
    typeof crypto !== 'undefined' && 'getRandomValues' in crypto
      ? crypto.getRandomValues(new Uint32Array(1))[0].toString(36)
      : Math.random().toString(36).slice(2)
  counter = (counter + 1) % 1e6
  return `${prefix}_${Date.now().toString(36)}${counter.toString(36)}${rand}`
}
